import type { TalkActions } from "@mgdx/talk/stores/talkStore";
import { signoutFirebase } from "@mgdx-libs/firebase";

import { clearTokenAndState } from "./clearTokenAndState";

export const signoutAndClearToken = async (disableTalk: TalkActions["disableTalk"]) => {
  await signoutFirebase();
  clearTokenAndState(disableTalk);
};
